import { Injectable } from '@angular/core';
import {UtilitiesService} from './utilities.service';
import {Angulartics2} from 'angulartics2';

@Injectable()
export class UrlParamsService {

    constructor(private utilitiesService: UtilitiesService,
                private angulartics2: Angulartics2) { }

    addTrackingParams(prospect: any) {

        let gtmVariables: any = {};

        // if we have google parameters, add them
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_medium"))) {
            prospect.channel = this.utilitiesService.getLocal("utm_medium");
            gtmVariables.utmMedium = this.utilitiesService.getLocal("utm_medium");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_campaign"))) {
            prospect.campaign = this.utilitiesService.getLocal("utm_campaign");
            gtmVariables.utmCampaign = this.utilitiesService.getLocal("utm_campaign");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_source"))) {
            prospect.referrer = this.utilitiesService.getLocal("utm_source");
            gtmVariables.utmSource = this.utilitiesService.getLocal("utm_source");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_term"))) {
            prospect.keyword = this.utilitiesService.getLocal("utm_term");
            gtmVariables.utmTerm = this.utilitiesService.getLocal("utm_term");
        } else if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("keyword"))) {
            prospect.keyword = this.utilitiesService.getLocal("keyword");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_content"))) {
            prospect.content = this.utilitiesService.getLocal("utm_content");
            gtmVariables.utmContent = this.utilitiesService.getLocal("utm_content");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("utm_id"))) {
            prospect.utmId = this.utilitiesService.getLocal("utm_id");
            gtmVariables.utmId = this.utilitiesService.getLocal("utm_id");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("adgroup"))) {
            prospect.adGroup = this.utilitiesService.getLocal("adgroup");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("network"))) {
            prospect.network = this.utilitiesService.getLocal("network");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("matchtype"))) {
            prospect.matchType = this.utilitiesService.getLocal("matchtype");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("creative"))) {
            prospect.creative = this.utilitiesService.getLocal("creative");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("adposition"))) {
            prospect.adPosition = this.utilitiesService.getLocal("adposition");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("service"))) {
            prospect.service = this.utilitiesService.getLocal("service");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("market"))) {
            prospect.market = this.utilitiesService.getLocal("market");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("device"))) {
            prospect.deviceCode = this.utilitiesService.getLocal("device");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("gclid"))) {
            prospect.gclId = this.utilitiesService.getLocal("gclid");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("fbclid"))) {
            prospect.fbclId = this.utilitiesService.getLocal("fbclid");
        }
        if (UtilitiesService.isNotEmpty(this.utilitiesService.getLocal("referral_source"))) {
            prospect.referralSource = this.utilitiesService.getLocal("referral_source");
        }

        // push params to the GTM data layer
        this.angulartics2.eventTrack.next({
            action: "saveReferralInfo",
            properties: {
                category: "before page load",
                label: "success",
                gtmCustom: gtmVariables
            }
        });

        return prospect;

    } // addTrackingParams()

    clearTrackingParams() {

        this.utilitiesService.setLocal("utm_medium", "");
        this.utilitiesService.setLocal("utm_campaign", "");
        this.utilitiesService.setLocal("utm_source", "");
        this.utilitiesService.setLocal("utm_term", "");
        this.utilitiesService.setLocal("keyword", "");
        this.utilitiesService.setLocal("utm_content", "");
        this.utilitiesService.setLocal("adgroup", "");
        this.utilitiesService.setLocal("network", "");
        this.utilitiesService.setLocal("matchtype", "");
        this.utilitiesService.setLocal("creative", "");
        this.utilitiesService.setLocal("adposition", "");
        this.utilitiesService.setLocal("service", "");
        this.utilitiesService.setLocal("device", "");
        this.utilitiesService.setLocal("gclid", "");
        this.utilitiesService.setLocal("fbclid", "");
        this.utilitiesService.setLocal("referral_source", "");

    } // clearTrackingParams()

}
